import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../i18n/LanguageContext';

const BannerContainer = styled.div`
  background-color: var(--bg-secondary);
  padding: 1.5rem 0;
  text-align: center;
  border-bottom: 1px solid var(--border-color);
`;

const BannerText = styled.h3`
  font-size: 1.2rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: var(--text-secondary);
`;

interface HeaderBannerProps {
  textKey?: string;
}

const HeaderBanner: React.FC<HeaderBannerProps> = ({ textKey = 'header.banner' }) => {
  const { t } = useLanguage();

  return (
    <BannerContainer>
      <BannerText>
        {t(textKey)}
      </BannerText>
    </BannerContainer>
  );
};

export default HeaderBanner; 